import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --vh: 1vh;
    --primary-color: #ffffff;
    --secondary-color: #000000;
  }

  html {
    scroll-behavior: smooth;
    scroll-snap-type: y proximity;
    height: 100%;
    overflow-x: hidden;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    overflow-x: hidden;
    background: linear-gradient(180deg, 
                              #ffffff 0%, 
                              #f5f5f5 10%,
                              #e0e0e0 20%, 
                              #b0b0b0 40%, 
                              #808080 60%, 
                              #505050 80%, 
                              #000000 100%) fixed;
    background-size: 100% 200vh;
    background-repeat: no-repeat;
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    color: #f1f1f1;
    position: relative;
  }

  /* Light effect overlay */
  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      radial-gradient(
        circle at 50% 10%, 
        rgba(255,255,255,0.3) 0%, 
        rgba(255,255,255,0.1) 20%, 
        rgba(255,255,255,0) 60%
      );
    pointer-events: none;
    z-index: 2;
  }

  section {
    scroll-snap-align: start;
    height: 100vh;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

export default GlobalStyles;